import { Controller } from 'stimulus';

const cents = (field) => Math.round((parseFloat(field.value) || 0) * 100);

export default class extends Controller {
  static targets = ['unitPrice', 'markup', 'price', 'msrp', 'msrpField', 'offRetail'];

  static values = {
    productId: Number,
    invalidMessage: String,
  };

  priceFromMarkup() {
    const unitPrice = cents(this.unitPriceTarget);
    const markup = parseFloat(this.markupTarget.value) || 0;

    this.priceTarget.value = ((unitPrice + unitPrice * (markup / 100)) / 100).toFixed(2);
    this.#priceChanged();
  }

  markupFromPrice() {
    const unitPrice = cents(this.unitPriceTarget);
    const price = cents(this.priceTarget);

    if (unitPrice > 0 && price >= unitPrice) {
      this.markupTarget.value = (((price - unitPrice) / unitPrice) * 100).toFixed(2);
    }

    this.#priceChanged();
  }

  revealMsrp(event) {
    event.currentTarget.remove();
    this.msrpFieldTarget.hidden = false;
    this.msrpTarget.focus();
  }

  refreshDiscount() {
    const msrp = cents(this.msrpTarget);
    const price = cents(this.priceTarget);
    const offRetail = msrp > 0 ? Math.round(100 - (price * 100) / msrp) : 0;

    this.offRetailTarget.textContent = offRetail > 0 ? `${offRetail}% off retail` : '';
  }

  submitted({ detail }) {
    if (!detail.success) {
      return;
    }

    this.dispatch('updated', {
      prefix: 'shoppable',
      target: document,
      detail: { kind: 'product', id: this.productIdValue },
    });
  }

  #priceChanged() {
    const invalid = cents(this.priceTarget) < cents(this.unitPriceTarget);

    this.priceTarget.setCustomValidity(invalid ? this.invalidMessageValue : '');
    this.refreshDiscount();
  }
}
